import {IParticularColor} from '@toolify/server/src/services/ColorService/types/IParticularColor'

export function areParticularColorsEqual(particularColor1: IParticularColor, particularColor2: IParticularColor): boolean {
  return particularColor1?.colorType === particularColor2?.colorType && JSON.stringify(particularColor1?.payload) === JSON.stringify(particularColor2?.payload)
}
